import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchPendingApprovalList } from "../../redux";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import style from "./ArchiveApprovalList.module.css";
import { Link } from "react-router-dom";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Dropdown from "../../utils/Dropdown.json";
import api from "../../utils/Api";
import history from "../../utils/history";
import moment from "moment";
import ttmLodader from "../../assets/images/ttm-loader.gif";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class PendingApprovalList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      related_party_id: "",
      isModalOpen: false,
      reasonType: "",
      label: "",
      other: "",
      searchKey: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      sortBy: "",
      successMessage: "",
      errorMessage: "",
      errorField: "",
      archivedApprovalList: [],
      system_role:
        localStorage.getItem("USER_INFO") &&
        JSON.parse(localStorage.getItem("USER_INFO")).systemRole,
      isPendingDeletionScreen: 0,
      isDataFetched: false,
    };
    this.toggle = this.toggle.bind(this);
    this.setLoader = this.setLoader.bind(this);
  }

  componentDidMount = async() => {
    document.title = 'Archived Approval List - TechToMedix';
   await this.props.fetchPendingApprovalList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      this.state.isPendingDeletionScreen
    );
    if(this.props.pendingApprovalListData && 
      this.props.pendingApprovalListData.pendingApprovalList && 
      this.props.pendingApprovalListData.pendingApprovalList.relatedParty

      ) {
      this.setState({
        archivedApprovalList: this.props.pendingApprovalListData.pendingApprovalList.relatedParty
      })
    }
    setTimeout(() => {
      if (this.props.pendingApprovalListData.pendingApprovalList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  }

  callArchvieApprovalList = async() => {
    this.setState({
      archivedApprovalList: [],
    });
    await this.props.fetchPendingApprovalList(
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      this.state.isPendingDeletionScreen
    );
    if(!this.props.pendingApprovalListData.loading){
      this.setState({
        archivedApprovalList: this.props.pendingApprovalListData.pendingApprovalList.relatedParty
      })
      setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
      }, 1000);
    }
  }

  // toggle a modal
  toggle(val) {
    this.setState((prevState) => ({
      related_party_id: val,
      isModalOpen: !prevState.isModalOpen,
    }));
  }

  actionsFormatter(cell, row) {
    return (
      <div>
        <i className="fa fa-check"></i>
      </div>
    );
  }

  handleSelectChange = (e) => {
    let index = e.nativeEvent.target.selectedIndex;
    let label = e.nativeEvent.target[index].text;
    let value = e.target.value;
    this.setState({ reasonType: value, label: label });
  };

  handleInputChange = (e) => {
    this.setState({ other: e.target.value });
  };

  handleBlurChange = () => {
    if (this.state.reasonType === "Other" && this.state.other !== "") {
      this.setState({ errorField: "" });
    }
  };

  onSubmit = async (e) => {

    e.preventDefault();
     this.setState({
          errorMessage: "",
        });
    // get our form data out of state
    const { reasonType, other, label } = this.state;
    if (reasonType === "" || (reasonType === "4" && other === "")) {
      this.setState({
        errorField: "This field is required",
      });
    } else {
      this.setState({ errorField: "" });
      try {
        const response = await api.delete("relatedparty/deletion/request", {
          headers: {
            Authorization:
              "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
          },
          data: {
            related_party_id: this.state.related_party_id.related_party_id,
            deletion_reason_id: Number(reasonType),
            deleted_reason: label !== "Other" ? label : other,
          },
        });
        if (response.status === 200) {
          this.setState({
            successMessage: response.data.message,
          });
          setTimeout(() => {
            this.setState((prevState) => ({
              successMessage: "",
              isModalOpen: !prevState.isModalOpen,
            }));
          }, 3000);
        }
      } catch (error) {
        this.setState({
          errorMessage: error.response.data.message,
        });
        // setTimeout(() => {
        //   this.setState((prevState) => ({
        //     errorMessage: "",
        //   }));
        // }, 3000);
      }
    }
  };

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=> {
    if (sortName != "any") {
      this.callArchvieApprovalList();
    }
    });
  };

  onSearchChange = (event) => {
    this.setState({ 
      searchKey: event.target.value, 
      page: 1, 
      isDataFetched: false 
    },()=>{
      this.callArchvieApprovalList();
    });
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({ 
      page, 
      isDataFetched: true 
    },()=>{
      this.callArchvieApprovalList();
    });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  render() {
    // Getting deleted reasons
    const deleteReasons = Dropdown.deleted_reason.map((element, index) => (
      <option key={index} value={element.deleted_reason_id}>
        {element.deleted_reason}
      </option>
    ));

    return (
      <div className={style.relatedPartiesListMainWarapper}>
        <div className="">
          <div className={style.relatedPartiesListMainWarapper}>
            <div className="row">
              <div className="col-md-7">
                <h3>Archived Contacts</h3>
              </div>
              <div
                className={`col-md-5 order-3 order-md-2 d-flex justify-content-start justify-content-md-end `}
              >
               <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${style.inputSearch}`}
                    id="search"
                    placeholder="Search here"
                    value={this.state.searchKey}
                    onChange={this.onSearchChange}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div class="col-md-12">
                  <p>
                  All the Contacts that have been deleted on the system and have been approved will be displayed here. 
                  It is intended to show a track of all the Contacts that have been deleted on the system.
                  </p>
                </div>
            </div>
            <div className="row related-parties-list">
              <div className="col-md-12">
                <BootstrapTable
                  bordered={false}
                  remote={true}
                  data={this.state.archivedApprovalList
                  }
                  version="4"
                  search={false}
                  pagination
                  fetchInfo={{
                    dataTotalSize: this.props.pendingApprovalListData
                      .pendingApprovalList.total,
                  }}
                  options={{
                    searchvalue: "",
                    sortName: this.state.sortName,
                    sortOrder: this.state.sortOrder,
                    onSortChange: this.onSortChange,
                    onSearchChange: this.onSearchChange,
                    sizePerPage: 10,
                    page: this.state.page,
                    onPageChange: this.onPageChange,
                    noDataText: this.setLoader(),
                  }}
                >
                  <TableHeaderColumn
                    dataField="name"
                    isKey
                    width="20%"
                    dataSort={true}
                  >
                    Contact Name
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="deleted_reason"
                    width="30%"
                    dataSort={true}
                  >
                    Deletion reason
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="deletion_request_date"
                    width="15%"
                    dataSort={true}
                    dataFormat={dateFormatter}
                  >
                    Date
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="raisedRequestBy"
                    width="20%"
                    dataSort={true}
                  >
                    Raised By
                  </TableHeaderColumn>
                  {this.state.system_role == 1 && (
                    <TableHeaderColumn dataField="deletion_status" width="15%">
                      Deletion
                    </TableHeaderColumn>
                  )}
                </BootstrapTable>
              </div>
            </div>
          </div>

          {/* Open a modal for delete reason */}
          <Modal
            isOpen={this.state.isModalOpen}
            toggle={this.toggle}
            className={style.deleteReason}
            centered
          >
            <ModalHeader
              toggle={this.toggle}
              className={style.deleteModalHeader}
            ></ModalHeader>
            <ModalBody>
              <div className={style.deleteReasonHeadingWrapper}>
                <h4>
                  Please confirm whether you want to delete the entry. Also,
                  mention the reason for deletion.
                </h4>
              </div>
              <div className={style.deleteReasonFormWrapper}>
                <form onSubmit={this.onSubmit}>
                  <div className="form-group">
                    <select
                      className={`form-control ${style.customFormControl}`}
                      id="reasonType"
                      value={this.state.reasonType}
                      onChange={this.handleSelectChange}
                      name="reasonType"
                    >
                      <option value="">Select Reason Type</option>
                      {deleteReasons}
                    </select>
                  </div>
                  {this.state.label === "Other" && (
                    <div className="form-group">
                      <textarea
                        className={`form-control ${style.customFormControl}`}
                        id="other"
                        rows="3"
                        name="other"
                        onChange={this.handleInputChange}
                        onBlur={this.handleBlurChange}
                      ></textarea>
                    </div>
                  )}
                  <div className={style.error}>{this.state.errorField}</div>
                  <div className={`row ${style.deleteBtnWrapper}`}>
                    <button type="submit" className={style.deleteBtn}>
                      Submit
                    </button>

                    <button
                      type="button"
                      className={style.cancelBtn}
                      onClick={this.toggle}
                    >
                      Cancel
                    </button>
                  </div>
                  <div className="row">
                    <p className={style.successMessage}>
                      {this.state.successMessage}
                    </p>
                    <p className={style.errorMessage}>
                      {this.state.errorMessage}
                    </p>
                  </div>
                </form>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pendingApprovalListData: state.pendingApprovalList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPendingApprovalList: (
      searchKey,
      sortBy,
      page,
      isPendingDeletionScreen
    ) =>
      dispatch(
        fetchPendingApprovalList(
          searchKey,
          sortBy,
          page,
          isPendingDeletionScreen
        )
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PendingApprovalList);
